<template>
  <el-form
    :model="optionData"
    :rules="optionRules"
    label-width="100px"
  >
    <el-form-item label="图形标题" prop="title">
      <el-input style="width: 320px;max-width: 500px;" placeholder="请输入柱状图显示标题..." :minlength="3" :maxlength="20" v-model="optionData.title"></el-input>
    </el-form-item>
    <el-form-item label="标题颜色" prop="titleColor">
      <el-color-picker popper-class="my-color-picker" v-model="optionData.titleColor" show-alpha></el-color-picker>
      <div>
        <el-link type="primary">tip：默认标题颜色灰黑色。</el-link>
      </div>
    </el-form-item>
    <el-form-item label="y轴单位" prop="unit">
      <el-input style="width: 320px;max-width: 500px;" placeholder="请输入y轴单位..." :minlength="1" :maxlength="3" v-model="optionData.unit"></el-input>
    </el-form-item>
    <el-form-item label="图形背景色" prop="background">
      <el-color-picker popper-class="my-color-picker" v-model="optionData.background" show-alpha></el-color-picker>
      <div>
        <el-link type="primary">tip：默认背景色透明。</el-link>
      </div>
    </el-form-item>
    <el-form-item label="XY轴字体颜色" prop="fontColor">
      <el-color-picker popper-class="my-color-picker" v-model="optionData.fontColor" show-alpha></el-color-picker>
      <div>
        <el-link type="primary">tip：默认灰黑色字体。</el-link>
      </div>
    </el-form-item>
    <el-form-item label="条形字体颜色" prop="barFontColor">
      <el-color-picker popper-class="my-color-picker" v-model="optionData.barFontColor" show-alpha></el-color-picker>
      <div>
        <el-link type="primary">tip：默认灰黑色字体。</el-link>
      </div>
    </el-form-item>
    <el-form-item label="显示坐标轴线" prop="disAxis">
      <el-switch v-model="optionData.disAxis"></el-switch>
    </el-form-item>
    <el-form-item label="坐标轴线颜色" prop="axisColor">
      <el-color-picker popper-class="my-color-picker" v-model="optionData.axisColor" show-alpha></el-color-picker>
      <div>
        <el-link type="primary">tip：只在显示坐标轴线情况下生效。</el-link>
      </div>
    </el-form-item>
    <el-form-item label="显示网格线" prop="splitLine">
      <el-switch v-model="optionData.splitLine"></el-switch>
    </el-form-item>
    <el-form-item label="网格线颜色" prop="splitLineColor">
      <el-color-picker popper-class="my-color-picker" v-model="optionData.splitLineColor" show-alpha></el-color-picker>
      <div>
        <el-link type="primary">tip：只在显示网格线情况下生效。</el-link>
      </div>
    </el-form-item>
    <el-form-item label="横向柱状图" prop="xAlign">
      <el-switch v-model="optionData.xAlign"></el-switch>
    </el-form-item>
    <el-form-item label="刻度标签对齐" prop="scaleAlign">
      <el-switch v-model="optionData.scaleAlign"></el-switch>
    </el-form-item>
    <el-form-item label="背景色水印" prop="backWatermark">
      <el-switch v-model="optionData.backWatermark"></el-switch>
    </el-form-item>
    <el-form-item label="柱条区分颜色" prop="randomColor">
      <el-switch v-model="optionData.randomColor"></el-switch>
      <div>
        <el-link type="primary">tip：只针对一组数据不同条形显示不同颜色，多组数据不生效。</el-link>
      </div>
    </el-form-item>
    <el-form-item label="显示平均值" prop="average">
      <el-switch v-model="optionData.average"></el-switch>
    </el-form-item>
    <el-form-item label="显示最值" prop="maxmin">
      <el-switch v-model="optionData.maxmin"></el-switch>
    </el-form-item>
    <el-form-item label="堆叠排列" prop="stacking">
      <el-switch v-model="optionData.stacking"></el-switch>
    </el-form-item>
    <el-form-item label="折线柱形转换" prop="toLine">
      <el-switch v-model="optionData.toLine"></el-switch>
    </el-form-item>
    <el-form-item label="显示图例" prop="legend">
      <el-switch v-model="optionData.legend"></el-switch>
    </el-form-item>
    <el-form-item label="提供图片下载" prop="saveAsImage">
      <el-switch v-model="optionData.saveAsImage"></el-switch>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      optionData: {
        title: "", // 标题
        titleColor: "#333", // 标题颜色
        unit: "", // y轴单位
        background: "#00000000", // 默认背景色
        fontColor: "#333", // 字体颜色
        barFontColor: "#333", // 条形字体颜色
        disAxis: true, // 显示坐标轴线
        axisColor: "#333", // 坐标轴线颜色
        splitLine: false, // 显示网格线
        splitLineColor: "#ccc", // 网格线颜色
        xAlign: false, // 横向柱状图
        scaleAlign: false, // 刻度标签对齐
        backWatermark: false, // 背景色水印
        randomColor: false, // 柱条随机生成颜色
        average: false, // 显示平均值
        maxmin: false, // 显示最大最小值
        stacking: false, // 堆叠条形图
        toLine: false, // 折线图与条形图转换
        legend: false, // 显示图例
        saveAsImage: false,
      },
      optionRules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { min: 3, max: 20, message: "长度在 3 到 20 个字符", trigger: "blur" },
        ],
        unit: [
          { required: true, message: "请输入单位", trigger: "blur" },
          { min: 1, max: 3, message: "长度在 1 到 3 个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    getOption() {
      if(!this.optionData.title.trim()) {
        return "请输入图形标题！"
      }
      if(!this.optionData.unit.trim()) {
        return "请输入y轴单位！"
      }
      return JSON.parse(JSON.stringify(this.optionData))
    }
  }
};
</script>

<style>
.my-color-picker {
    z-index: 10001!important;
}
</style>